import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { DashboardLayout } from '../layout/DashboardLayout';
import { ProtectedRoute } from './ProtectedRoute';
import { LoadingSkeleton } from '../components/common/LoadingSkeleton';

// Lazy loading feature views
const Dashboard = lazy(() => import('../pages/Dashboard').then(m => ({ default: m.Dashboard })));
const Users = lazy(() => import('../pages/Users').then(m => ({ default: m.Users })));
const Verification = lazy(() => import('../pages/Verification').then(m => ({ default: m.Verification })));
const Matches = lazy(() => import('../pages/Matches').then(m => ({ default: m.Matches })));
const Invitations = lazy(() => import('../pages/Invitations').then(m => ({ default: m.Invitations })));
const Events = lazy(() => import('../pages/Events').then(m => ({ default: m.Events })));
const Venues = lazy(() => import('../pages/Venues').then(m => ({ default: m.Venues })));
const Participants = lazy(() => import('../pages/Participants').then(m => ({ default: m.Participants })));
const Subscriptions = lazy(() => import('../pages/Subscriptions').then(m => ({ default: m.Subscriptions })));
const SpecialOffers = lazy(() => import('../pages/SpecialOffers').then(m => ({ default: m.SpecialOffers })));
const Payments = lazy(() => import('../pages/Payments').then(m => ({ default: m.Payments })));
const Analytics = lazy(() => import('../pages/Analytics').then(m => ({ default: m.Analytics })));
const Reports = lazy(() => import('../pages/Reports').then(m => ({ default: m.Reports })));
const Moderators = lazy(() => import('../pages/Moderators').then(m => ({ default: m.Moderators })));
const Partners = lazy(() => import('../pages/Partners').then(m => ({ default: m.Partners })));
const SupportTickets = lazy(() => import('../pages/SupportTickets').then(m => ({ default: m.SupportTickets })));
const Notifications = lazy(() => import('../pages/Notifications').then(m => ({ default: m.Notifications })));
const EmailCampaigns = lazy(() => import('../pages/EmailCampaigns').then(m => ({ default: m.EmailCampaigns })));
const CMS = lazy(() => import('../pages/CMS').then(m => ({ default: m.CMS })));
const Categories = lazy(() => import('../pages/Categories').then(m => ({ default: m.Categories })));
const Settings = lazy(() => import('../pages/Settings').then(m => ({ default: m.Settings })));
const RolesPermissions = lazy(() => import('../pages/RolesPermissions').then(m => ({ default: m.RolesPermissions })));
const SystemLogs = lazy(() => import('../pages/SystemLogs').then(m => ({ default: m.SystemLogs })));
const Login = lazy(() => import('../pages/Login').then(m => ({ default: m.Login })));
const NotFound = lazy(() => import('../pages/NotFound').then(m => ({ default: m.NotFound })));
const Unauthorized = lazy(() => import('../pages/Unauthorized').then(m => ({ default: m.Unauthorized })));

export const AppRoutes = () => {
  return (
    <Suspense fallback={<LoadingSkeleton type="cards" />}>
      <Routes>
        {/* Guest Routes */}
        <Route path="/login" element={<Login />} />

        {/* Protected Dashboard Shell Routes */}
        <Route element={<ProtectedRoute />}>
          <Route element={<DashboardLayout />}>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/users" element={<Users />} />
            <Route path="/verification" element={<Verification />} />
            <Route path="/matches" element={<Matches />} />
            <Route path="/invitations" element={<Invitations />} />
            <Route path="/events" element={<Events />} />
            <Route path="/venues" element={<Venues />} />
            <Route path="/participants" element={<Participants />} />
            <Route path="/subscriptions" element={<Subscriptions />} />
            <Route path="/special-offers" element={<SpecialOffers />} />
            <Route path="/payments" element={<Payments />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/moderators" element={<Moderators />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/support-tickets" element={<SupportTickets />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/email-campaigns" element={<EmailCampaigns />} />
            <Route path="/cms" element={<CMS />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/roles-permissions" element={<RolesPermissions />} />
            <Route path="/system-logs" element={<SystemLogs />} />
            <Route path="/unauthorized" element={<Unauthorized />} />
          </Route>
        </Route>

        {/* Fallback 404 Route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
};
